module.exports = "/static/images/logo-moss.svg";